import React, { useState, useEffect } from "react";
import { PurchasedTokensStyle as styles } from "../../purchaseHistory.tailwind";
import PurchasedTokenTableList from "./PurchasedTokenTableList";
import { Chip } from "@mui/material";
import { getTransactionStatus } from "../../../../lib/utils/paymentStatusUtils";
import { formatDate } from "../../../../lib/utils/dateAndTimeFormatting";

const PurchasedTokens = ({ order }) => {
  const { orderTotal, checkoutStartTime, orderItems } = order;
  const [expandedZones, setExpandedZones] = useState({});
  const transactionID = order?.paymentDetails?.transactionId?.split("_")?.length > 1 ? order?.paymentDetails?.transactionId?.split("_")[1] : order?.paymentDetails?.transactionId;
  const { transactionStatus, statusColor } = getTransactionStatus(order?.paymentDetails?.transactionStatus);
  
  // To expand and collapse the zones
  const handleToggle = (zoneCategoryName) => {
    setExpandedZones((prev) => ({
      ...prev,
      [zoneCategoryName]: !prev[zoneCategoryName],
    }));
  };

  useEffect(() => {
    const initialExpandedZones = {};
    orderItems.forEach((item) => {
      initialExpandedZones[item.zoneCategoryName] = true;
    });
    setExpandedZones(initialExpandedZones);
  }, [orderItems]);

  return (
    <div className={styles.container}>
      {/* Conditionally render the spinner or the order details */}
      {/* {ordersLoading ? (
        <div className={styles.spinnerContainer}>
          <Spinner />
        </div>
      ) : ( */}
        <div>
          {/* Order details container */}
          <div className={styles.header}>
            {/* <div className={styles.orderDetails}> */}
              {/* <div className={styles.orderDate}> */}
                {/* <span className={styles.heading}>Order Placed</span> */}
                {/* Order date */}
                {/* <span className={styles.date}>{formatDate(checkoutStartTime)}</span>         */}
              {/* </div> */}

              {/* Order ID and payment method */}
              {/* <div className={styles.orderId}> */}
              <div>
                <div className="flex gap-[15px]">
                  <span className={styles.date}>{formatDate(checkoutStartTime)}</span>   
                  <Chip label={transactionStatus} color={statusColor} size="small" />
                </div>
                <div className={styles.headerContainer}>
                  <span className={styles.heading}>Transaction Id </span>
                  <span className={styles.orderCode}> # {transactionID}</span>
                </div>
                {order?.paymentDetails?.paymentMethod  && <div className={styles.headerContainer}>
                  {/* <div > */}
                  <span className={styles.heading}>Payment Method </span>
                  <span className={styles.paymentMethod}>

                  {order?.paymentDetails?.paymentMethod === "card" && order?.paymentDetails?.cardEndingNumber ? (
                    <div className={styles.paymentMethod}>
                      <span className={styles.paymentMethod}>
                        {order?.paymentDetails?.paymentMethod === "card" && order?.paymentDetails?.displayBrand} {order?.paymentDetails?.paymentMethod}
                      </span>
                      <span className={styles.paymentMethod}>( Ending in</span>
                      <span className={styles.paymentMethod}>{order?.paymentDetails?.cardEndingNumber} )</span>
                    </div>
                    ) : (
                    <div className={styles.paymentMethod}>
                      <span className={styles.paymentMethod}>
                        {order?.paymentDetails?.paymentMethod}
                      </span>
                    </div>
                  )}
                  </span>
                  {/* </div> */}

                </div>}
              </div>
              {/* </div> */}
            {/* </div> */}

            {/* Order total (including taxes) */}
            <div className={styles.total_status}>
              <div className={styles.totalContainer}>
                <span className={styles.heading}>Total</span>
                {/* <span className={styles.heading}> */}
                  <div>
                    <span className={`${styles.totalText}`}> ${orderTotal.toFixed(2)} </span> <span className="text-[11px] md:hidden">(Inc. Taxes)</span>
                {/* </span> */}
                {/* <span className={` md:hidden ${styles.totalText}`}> ${orderTotal.toFixed(2)} </span> */}
                    <span className="text-[11px] max-md:hidden">(Inc. Taxes)</span>
                    </div>
              </div>
            </div>
          </div>

          {/* Listing of tokens according to zones */}
          <div className={styles.detailsSection}>
            {orderItems.map((item, index) => (
              <PurchasedTokenTableList key={index} item={item} handleToggle={handleToggle} expandedZones={expandedZones} />
            ))}
          </div>
        </div>
      {/* // )} */}
    </div>
  );
};

export default PurchasedTokens;
